// 该中心下所有的离职人员表格字段
export const tableColumns = [
 { label: '工号', prop: 'psnCode', minWidth: '120' },
 { label: '姓名', prop: 'psnName', minWidth: '120' },
 { label: '组别', prop: 'userGrpName', minWidth: '120' },
 { label: '职位', prop: 'jobRoleName', minWidth: '120' },
 {
  label: '修改时间',
  prop: 'modifyTime',
  minWidth: '160',
  sortable: true
 }
]

// 离职转交记录表格字段
export const staffTableColumns = [
 { type: 'selection', fixed: 'left' },
 { label: '序号', type: 'index', width: '50', fixed: 'left' },
 { label: '离职人工号', prop: 'clientAccount', width: '120' },
 { label: '离职人姓名', prop: 'client', width: '120' },
 { label: '代理人工号', prop: 'userId', width: '120' },
 { label: '代理人姓名', prop: 'agent', width: '120' },
 { label: '流程名称', prop: 'procDefName' },
 { label: '修改人', prop: 'modifyUserName', width: '120' },
 { label: '修改时间', prop: 'modifyTime', width: '160' },
 {
  label: '操作', prop: 'operate', width: '160', btnList: [
   // { type: 'text', name: '修改', method: 'onEdit', size: 'small' },
   { type: 'text', name: '取消', method: 'cancelEntrust', size: 'small' },
  ]
 }
]

export const buttonList = [
 { name: '设置离职转交', type: 'primary', method: 'getTaskName', size: 'small' },
 { name: '批量取消', type: 'warning', size: 'small', method: 'cancelEntrust' },
]

// 设置离职转交字段
export const dialogFields = [
 { label: '任务流程', prop: 'procKeyAndDefNameList', type: 'select', checkboxName: "全选", multiple: true, fieldOption: { label: 'procDefName', value: 'key', options: [] }, placeholder: '请输入任务流程' },
 { label: '代理人', prop: 'agent', require: true, type: 'userSelect', placeholder: '请输入代理人姓名或工号' },
]
